import React, { useState, useEffect, useRef } from 'react';
import update from 'react-addons-update'; // ES6
import classnames from 'classnames';
import './App.scss';
import { goodTweets, badTweets, goodAvatars, badAvatars } from './tweets.js';
import ReactCursorPosition from 'react-cursor-position';
import ifEmoji from 'if-emoji';

function useInterval(callback, delay) {
  const savedCallback = useRef();

  // Remember the latest callback.
  useEffect(() => {
    savedCallback.current = callback;
  }, [callback]);

  // Set up the interval.
  useEffect(() => {
    function tick() {
      savedCallback.current();
    }
    if (delay !== null) {
      let id = setInterval(tick, delay);
      return () => clearInterval(id);
    }
  }, [delay]);
}

function random(array) {
	return array[Math.floor(Math.random() * array.length)];
}

// the state machine for tweets
class Twitter {
  constructor() {
    this.step = 0;
    this.state = "";
  }

  next(negative) {
    let out;
    let tweet;

    if (!negative) {
      out = {
        m: random(goodTweets),
        negative: false
      }
    } else {
      out = {
        m: random(badTweets),
        negative: true
      }
    }

    this.step += 1;
    return out;
  }

}

function Piece(props) {
  let appRef = useRef(null);
  let count = useRef(0);
  let countFromStart = useRef(0);
  const [interacted, setInteracted] = useState(false);
  let negative = useRef(false);
  let likeRate = useRef(0.6);
  const [artist, setArtist] = useState(random(["👨‍🎨","👩‍🎨","👨🏽‍🎨","👨🏿‍🎨","👨🏻‍🎨","👩🏻‍🎨","👨🏾‍🎨","👩🏾‍🎨","👨🏼‍🎨","👩🏼‍🎨"]));

  const [restrictedEmojis, setRestrictedEmojis] = useState(false);

  const [likes, setLikes] = useState(0);
  const [comments, setComments] = useState(0);
  const [tweets, setTweets] = useState([]);
  const [twitter, setTwitter] = useState(null);

  const [showMessage, setShowMessage] = useState(true);

  useEffect(() => {
    setTwitter(new Twitter());
    if(!ifEmoji("👩‍🦽")) {
      setRestrictedEmojis(true);
    }

    document.body.addEventListener('click', e => {
      negative.current = !negative.current;
      setInteracted(true);
    }, true); 
  }, []);

  const FRAME_START = 8;
  const TWEET_RATE = 6;
  
  useInterval(() => {
    count.current += 1;

    if (Math.random() < likeRate.current) {
      setLikes(likes + 1);
    }

    if ((countFromStart.current % TWEET_RATE == 0) && count.current > FRAME_START) {
      let next = twitter.next(negative.current);
      let newTweets = update(tweets, { $push: [ next ] });
      //newTweets = newTweets.slice(1, 20); // optimize
      setComments(comments + 1);
      if (!next.negative) {
        
      }
      setTweets(newTweets);          
    }

    if (count.current > FRAME_START) {
      countFromStart.current += 1;
    }
    //console.log(count.current);
  }, 400);

  return (
    <>
      {
        <style>
          {`
            body {
              background: rgba(${negative.current ? '80' : '0'}, ${negative.current ? '0' : '80'}, 0, 0.9);            
            }                    
          `}
        </style>    
      }
      <div className="noise-wrapper">
        <div className="noise"></div>    
      </div>
      
      <div id="app" ref={appRef}>

        {!interacted &&
          <div id="message">Tap to get canceled</div>
        }

        <div id="wrap">          
          
          <div className="op">            
            <div className="profile">
              {restrictedEmojis ? "" : artist}             
            </div>
            <div className="content">
              <div className="username">@an0n_art1st</div>
              <nobr>
                <span>look </span>
                <span>what </span>
                <span>i </span>
                <span>made!</span>
              </nobr>
              <div className="buttons">
                <div className="comment">
                  {comments}
                </div>
                <div className="like">
                  {likes}
                </div>
                <div className="clearfix"></div>
              </div>
              
            </div>
            <div className="photo"></div>
          </div>
          <div className="tweets">            
            {tweets.slice(0).reverse().map((tweet,i) => {
              return (       
                <Tweet restrict={restrictedEmojis} negative={tweet.negative} position={i} content={tweet.m} key={tweets.length-i} />
              );
            })}
          </div> 
        </div>
      </div>
    </>

  );
}

function App() {
  return(
    <ReactCursorPosition>
      <Piece />
    </ReactCursorPosition>
  )
  
}


function Tweet(props) {
  //const profileRef = useRef(null);

  
  let avatar = useRef(null);;
  
  if (!avatar.current) {
    if (props.restrict) {
      avatar.current = props.negative ? random(badAvatars.slice(0,5)) : random(goodAvatars.slice(0,5));
    } else {
      avatar.current = props.negative ? random(badAvatars) : random(goodAvatars);
    }
  }

  return (                                
    <div className={classnames({tweet: true, negative: props.negative })}>
      <div className="profile">
        {avatar.current}
      </div>
      <div className="content">              
        {props.content} 
      </div>
    </div>
  );
}

export default App;

